var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "settings",
      attrs: {
        options: { close: { onBlur: false, onEsc: false } },
        size: _vm.modalSize
      },
      on: {
        hidden: function($event) {
          return _vm.$emit("closed")
        }
      }
    },
    [
      _c("h3", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _c("i", { staticClass: "fas fa-road" }),
        _vm._v(
          " " +
            _vm._s(_vm.resource("JourneyBuilder_conditionsettings_Title")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "modal-body" }, slot: "modal-body" },
        [
          _c(
            "tabbed-menu",
            {
              attrs: {
                "initial-tab": _vm.initialTab,
                tabs: [
                  {
                    name: _vm.tabs.generalSettings,
                    label: _vm.resource(
                      "JourneyBuilder_conditionsettings_Title"
                    )
                  },
                  {
                    name: _vm.tabs.deduplicationSettings,
                    label: _vm.resource(
                      "JourneyBuilder_DeduplicationSettings_Title"
                    )
                  }
                ]
              }
            },
            [
              _c(
                "template",
                { slot: _vm.tabs.generalSettings },
                [
                  _c("journey-connection-general-settings", {
                    ref: "generalSettings",
                    attrs: {
                      "available-conditions": _vm.availableConditions,
                      connection: _vm.connection,
                      name: _vm.model.generalSettings.name,
                      "start-date": _vm.model.generalSettings.startDate,
                      "is-disabled": _vm.model.generalSettings.isDisabled,
                      delay: _vm.model.generalSettings.delay,
                      "steam-campaign": _vm.steamCampaign,
                      "email-campaign": _vm.emailCampaign,
                      "group-by-title": _vm.groupByTitle,
                      "action-conditions":
                        _vm.model.generalSettings.actionConditions,
                      "content-settings":
                        _vm.model.generalSettings.contentSettings,
                      "available-action-conditions":
                        _vm.availableActionConditions,
                      emailCampaigns: _vm.emailCampaigns,
                      steamCampaigns: _vm.steamCampaigns
                    },
                    on: {
                      validated: function($event) {
                        _vm.generalSettingsValid = $event
                      },
                      "update:name": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "name",
                          $event
                        )
                      },
                      "update:startDate": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "startDate",
                          $event
                        )
                      },
                      "update:start-date": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "startDate",
                          $event
                        )
                      },
                      "update:isDisabled": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "isDisabled",
                          $event
                        )
                      },
                      "update:is-disabled": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "isDisabled",
                          $event
                        )
                      },
                      "update:delay": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "delay",
                          $event
                        )
                      },
                      "update:steamCampaign": function($event) {
                        _vm.steamCampaign = $event
                      },
                      "update:steam-campaign": function($event) {
                        _vm.steamCampaign = $event
                      },
                      "update:emailCampaign": function($event) {
                        _vm.emailCampaign = $event
                      },
                      "update:email-campaign": function($event) {
                        _vm.emailCampaign = $event
                      },
                      "update:groupByTitle": function($event) {
                        _vm.groupByTitle = $event
                      },
                      "update:group-by-title": function($event) {
                        _vm.groupByTitle = $event
                      },
                      "update:actionConditions": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "actionConditions",
                          $event
                        )
                      },
                      "update:action-conditions": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "actionConditions",
                          $event
                        )
                      },
                      "update:contentSettings": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "contentSettings",
                          $event
                        )
                      },
                      "update:content-settings": function($event) {
                        return _vm.$set(
                          _vm.model.generalSettings,
                          "contentSettings",
                          $event
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: _vm.tabs.deduplicationSettings },
                [
                  _c("journey-connection-deduplication-settings", {
                    attrs: {
                      "is-disabled": _vm.model.deduplicationSettings.isDisabled,
                      "field-name": _vm.model.deduplicationSettings.fieldName
                    },
                    on: {
                      "update:isDisabled": function($event) {
                        return _vm.$set(
                          _vm.model.deduplicationSettings,
                          "isDisabled",
                          $event
                        )
                      },
                      "update:is-disabled": function($event) {
                        return _vm.$set(
                          _vm.model.deduplicationSettings,
                          "isDisabled",
                          $event
                        )
                      },
                      "update:fieldName": function($event) {
                        return _vm.$set(
                          _vm.model.deduplicationSettings,
                          "fieldName",
                          $event
                        )
                      },
                      "update:field-name": function($event) {
                        return _vm.$set(
                          _vm.model.deduplicationSettings,
                          "fieldName",
                          $event
                        )
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
        [
          _c("settings-controls", {
            attrs: {
              "disable-save": !_vm.isValid,
              prompt: {
                title: _vm.resource(
                  "JourneyBuilder_FilterSettings_Delete_Title"
                ),
                body: _vm.resource("JourneyBuilder_FilterSettings_Delete_Body")
              }
            },
            on: {
              cancel: function($event) {
                return _vm.$refs.settings.hide()
              },
              delete: _vm.deleteConnection,
              save: _vm.saveConnection
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }